import { render } from "./PortraitMode.vue?vue&type=template&id=032df6ac&scoped=true"
const script = {}

import "./PortraitMode.vue?vue&type=style&index=0&id=032df6ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032df6ac"]])

export default __exports__